import React, { useEffect, useState } from "react";
import { Header } from "./Header";
import homeBg from "../Project Images/homeBG.jpg";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import homeGrid1 from "../Project Images/homeGrid1.jpg";
import homeGrid2 from "../Project Images/homeGrid2.png";
import homeGrid3 from "../Project Images/homeGrid3.jpg";
import aboutPic1 from "../Project Images/aboutPic1.jpg";
import aboutPic2 from "../Project Images/aboutPic2.jpg";
import aboutPic3 from "../Project Images/aboutPic3.png";

export const Home = () => {
  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    setShowComponent(true);
  }, []);

  const containerStyle = {
    backgroundImage: `url(${homeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    height: "100vh",
    display: "flex",
    color: "black",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  };

  const contentStyle = {
    position: "absolute",
    left: "120px",
    bottom: "0px",
    fontSize: "22px",
    lineHeight: "2.0",
    padding: "10px",
    textShadow: "none",
    color: "black",
  };

  return (
    <>
      <Header />
      <div
        className={showComponent ? "about-container show" : "about-container"}
        style={containerStyle}
      >
        <h1
          style={{
            fontSize: "3rem",
            position: "absolute",
            left: "120px",
            bottom: "320px",
          }}
        >
          Empowering Growth <br /> Through <br /> Digital Solutions
        </h1>

        <div style={contentStyle}>
          <p>
            <b>
              Welcome to the future of marketing! We are thrilled to present
              TMG, <br />a dynamic and innovative marketing agency dedicated to
              fuelling your <br />
              business growth and success. In today's fast-paced digital
              landscape, <br /> we understand that effective marketing is the
              key to staying ahead of <br /> the competition, and that's
              precisely what we specialize in.
            </b>
          </p>
        </div>
      </div>

      <br />
      <br />
      <br />

      <CardGroup style={{ margin: "0 auto", maxWidth: "1200px" }}>
        <div className="row">
          <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={homeGrid1}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>Unlocking Your Digital Potential with TMG</b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  In a world driven by the digital revolution, it's an honour to
                  introduce TMG, your trusted partner in navigating the
                  ever-evolving landscape of <b>Digital Marketing.</b> We are
                  here to unlock the full potential of your brand in the digital
                  realm and ensure your success is not just a possibility but a
                  certainty
                </Card.Text>
              </Card.Body>
              {/* <Card.Footer>
            <small className="text-muted">Last updated 3 mins ago</small>
          </Card.Footer> */}
            </Card>
          </div>

          <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={homeGrid2}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>
                    Elevate Your Brand with TMG: A Transformative Partnership
                  </b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  At TMG, we don't just offer marketing services, we offer a
                  comprehensive partnership that will transform your brand and
                  elevate your business to new heights. Our mission is simple
                  but powerful to combine creativity, strategy, and technology
                  to drive results that matter to you.
                </Card.Text>
              </Card.Body>
              {/* <Card.Footer>
            <small className="text-muted">Last updated 3 mins ago</small>
          </Card.Footer> */}
            </Card>
            </div>

            <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={homeGrid3}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>
                    Unleashing Online Potential: Your Digital Success Starts
                    Here
                  </b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  We are a dynamic team of seasoned professionals who share a
                  common vision to make the <b>Web Work</b> for you. Our agency
                  was born from the belief that the online world holds endless
                  opportunities for businesses, and we're here to help you seize
                  them.
                </Card.Text>
              </Card.Body>
              {/* <Card.Footer>
            <small className="text-muted">Last updated 3 mins ago</small>
          </Card.Footer> */}
            </Card>
            </div>

            <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={aboutPic1}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>
                    Empowering Customer Connections: Maximizing Your Marketing
                    ROI
                  </b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  Customer relationships are at the heart of every successful
                  business. We'll help you connect with your audience on a
                  deeper level. <br />
                  We understand that every marketing dollar counts. Our
                  strategies are designed to deliver the best possible return on
                  your investment
                </Card.Text>
              </Card.Body>
            </Card>
            </div>

            <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={aboutPic2}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>
                    Elevating Your Brand: Standing Out in a Competitive Market
                  </b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  Your brand is your identity, and we're here to make sure it
                  shines. We'll help you create a brand that stands out in a
                  crowded market
                  <br />
                  We're committed to helping you achieve sustainable growth by
                  leveraging the latest marketing trends and technologies.
                </Card.Text>
              </Card.Body>
            </Card>
            </div>

            <div className="col-md-6 mb-4">
            <Card className="border-0 shadow">
              <Card.Img
                variant="top"
                src={aboutPic3}
                style={{ width: "588px", height: "420px" }}
              />
              <Card.Body>
                <Card.Title>
                  <b>Crafting Your Brand: From Strategy to Engagement</b>
                </Card.Title>
                <Card.Text style={{ fontSize: "18px" }}>
                  We'll help you create a strong, memorable brand that resonates
                  with your audience.
                  <br />
                  <li>Brand Strategy</li>
                  <li>Brand Identity</li>
                  <li>Logo Designing</li>
                  Engage your audience with compelling content that converts.
                  Data is the key to success, we'll help you make sense of it.
                </Card.Text>
              </Card.Body>
            </Card>
            </div>
        </div>
      </CardGroup>
    </>
  );
};
